import Marquee from "react-fast-marquee";

const items = [
  "Global Export",
  "Recyclable Metals",
  "Dubai Hub",
  "B2B Trading",
  "Aluminium 6063",
  "UBC Scrap",
  "Aluminium Wire",
  "Circular Economy",
];

export default function Ticker({ light = false }) {
  return (
    <div
      className={`py-6 border-y overflow-hidden ${
        light ? "border-white/10 bg-ink" : "border-gray-200 bg-white"
      }`}
      data-testid="ticker-marquee"
    >
      <Marquee speed={35} gradient={false}>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-black uppercase text-3xl md:text-4xl tracking-tight mx-6 ${
                light ? "text-stroke-light" : "text-stroke"
              }`}
            >
              {item}
            </span>
            <span className="w-2 h-2 bg-copper rotate-45 inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
